import { useState } from 'react';
import { Check, Pencil, Plus, X } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function ScheduleRoleField({ value, onChange, catalog }) {
  const [isManaging, setIsManaging] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [draft, setDraft] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const startEdit = (role) => {
    setEditingId(role.id);
    setDraft(role.name);
  };

  const save = async () => {
    setIsSaving(true);
    try {
      const previousName = catalog.roles.find((role) => role.id === editingId)?.name;
      const location = await catalog.saveRole({ id: editingId, name: draft });
      if (previousName === value) onChange(draft.trim().replace(/\s+/g, ' '));
      toast.success(location === 'local' ? 'Função salva neste dispositivo.' : 'Função salva para a equipe.');
      setEditingId(null);
      setDraft('');
    } catch (error) {
      toast.error(error?.message || 'Não foi possível salvar a função.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="mbv-role-field">
      <div className="mbv-role-field-line">
        <Select value={value || undefined} onValueChange={onChange}>
          <SelectTrigger aria-label="Escolher função"><SelectValue placeholder="Escolha a função" /></SelectTrigger>
          <SelectContent>
            {catalog.roles.map((role) => <SelectItem key={role.id} value={role.name}>{role.name}</SelectItem>)}
            {value && !catalog.roles.some((role) => role.name === value) && <SelectItem value={value}>{value} · função anterior</SelectItem>}
          </SelectContent>
        </Select>
        <Button type="button" variant="outline" size="sm" onClick={() => setIsManaging((open) => !open)} aria-expanded={isManaging}>
          {isManaging ? 'Fechar' : 'Gerenciar funções'}
        </Button>
      </div>

      {isManaging && (
        <div className="mbv-role-manager">
          <p className="mbv-role-manager-heading">Funções da equipe</p>
          <div className="mbv-role-manager-list">
            {catalog.roles.map((role) => (
              <div key={role.id} className="mbv-role-manager-row">
                <span>{role.name}</span>
                <button type="button" onClick={() => startEdit(role)} aria-label={`Editar função ${role.name}`}><Pencil size={15} /></button>
              </div>
            ))}
          </div>
          <div className="mbv-role-manager-compose">
            <Input value={draft} onChange={(event) => setDraft(event.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); save(); } }} placeholder={editingId ? 'Editar função' : 'Nova função'} aria-label={editingId ? 'Editar função' : 'Nova função'} />
            <Button type="button" onClick={save} disabled={isSaving || !draft.trim()} aria-label={editingId ? 'Salvar edição' : 'Criar função'}>{editingId ? <Check size={16} /> : <Plus size={16} />}</Button>
            {editingId && <Button type="button" variant="ghost" size="icon" onClick={() => { setEditingId(null); setDraft(''); }} aria-label="Cancelar edição"><X size={16} /></Button>}
          </div>
        </div>
      )}
    </div>
  );
}
